import { toast } from "react-toastify";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";
import { CheckboxItem } from "../../components/check/checkbox";
import SkillSearchInput from "./searchInput";

const { updateUserSkills } = useClientSignUpSteps.getState();

export default function SelectSkills({ handleClick, steps, currentStep }) {
  const {
    userSkills,
  } = useClientSignUpSteps();

  return (
    <>
      <div className="">
        <div className="flex justify-between">
          <label className="text-semibold" htmlFor="skill">Skills</label>

          <p className="text-black text-sm">{userSkills.length}/8</p>
        </div>

        <div className="flex flex-wrap gap-2 mt-4">
          {userSkills.map((skill, index) => {
            const selected = userSkills.find(each => each.id === skill.id)

            return (
              <CheckboxItem
                key={skill.id}
                selected={true}
                // disabled={userSkills.length === 8}
                onSelect={() => {
                  updateUserSkills(userSkills.filter(each => each.id !== selected?.id))
                }}
                cancellabe={true}
              >
                {skill.name}
              </CheckboxItem>
            );
          })}

          <SkillSearchInput
            selectedSkills={userSkills}
            onSkillSelect={(skill) => {
              if (userSkills.length === 8) {
                return toast.info('You have selected maximum number of skills')
              }

              updateUserSkills(
                [...userSkills, {
                  id: skill.id,
                  name: skill?.name,
                }])
            }}
          />
        </div>
      </div>
    </>
  );
}
